import { LucideMenu } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import { Accordion } from "../ui/accordion";
import { ScrollArea } from "../ui/scroll-area";
import { Sheet, SheetContent, SheetHeader, SheetTrigger } from "../ui/sheet";

import logo from "/logo.png";

import RenderSidebarRoutes from "./RenderSideBar";

import { IWorkspace } from "@/interfaces/workspace.interface";
import useMessageCounter from "@/pages/messages/hooks/useMessageCounter";
import { toggleMobileExpanded } from "@/redux/slices/configSlice";
import { RootState } from "@/redux/store";

const MobileSidebar = (): React.JSX.Element => {
  const expanded = useSelector((state: RootState) => state.config.mobileExpand);

  const dispatch = useDispatch();

  const workspace = (): IWorkspace | null => {
    try {
      const ws = localStorage.getItem("workspaceData");

      if (ws) {
        return JSON.parse(ws) as IWorkspace;
      }
    } catch (error) {
      return null;
    }

    return null;
  };

  // for message count
  const { updatedBusinessRoutes } = useMessageCounter();

  return (
    <div className='absolute right-0 mr-2 shadow-sm lg:hidden'>
      <Sheet
        open={expanded}
        onOpenChange={() => dispatch(toggleMobileExpanded())}
      >
        <SheetTrigger className='w-full h-full place-content-center'>
          <LucideMenu size={25} />
        </SheetTrigger>
        <SheetContent
          className='w-full min-h-screen pt-6 overflow-y-auto lg:hidden  scrollbar-none max-w-[70dvw]'
          side={"left"}
        >
          <SheetHeader>
            <div className='flex justify-between w-full p-2 rounded-md align-center '>
              <div className='flex justify-center align-center border-b-1'>
                <img
                  src={workspace()?.logo || logo}
                  className={` transition-all w-10 mr-4  rounded-md`}
                  alt='logo'
                />
                <h3 className='mt-1 text-xl font-normal place-self-center'>
                  {workspace()?.name || "ALD Corporate"}
                </h3>
              </div>
            </div>
          </SheetHeader>
          <ul>
            <ScrollArea className='flex-1 min-h-screen mt-4'>
              <Accordion type='single' collapsible className='space-y-2'>
                {RenderSidebarRoutes({ updatedBusinessRoutes })}
              </Accordion>
            </ScrollArea>
          </ul>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default MobileSidebar;
